import React, { useState } from 'react';
import reconciliationAPI from './services/reconciliationApi';
import { formatApiError } from '../../utils/errorMessage';
import api from '../../services/api';
import { startingBalanceMessage } from '../accounts/StartingBalanceFields';

const usd = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);

// Starting balance for an account: the balance at the end of a given day.
// Transactions after that day (imported or typed in) then move the balance.
export default function StartingBalanceForm({ account, onSaved }) {
  const [amount, setAmount] = useState(account.opening_balance ?? '');
  const [date, setDate] = useState(account.opening_balance_date || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const body = { opening_balance: amount, opening_balance_date: date };
      // Same preview as the account form: show the effect, save on confirm.
      const preview = (await api.put(`/reconciliation/opening-balance/${account.account_id}?preview=1`, body)).data || {};
      if (!window.confirm(startingBalanceMessage(Number(preview.previous_balance) || 0, Number(preview.current_balance) || 0, usd))) return;
      await reconciliationAPI.setOpeningBalance(account.account_id, body);
      onSaved();
    } catch (err) {
      setError(formatApiError(err, 'Could not save the starting balance'));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={save} className="flex flex-wrap items-end gap-2 text-sm">
      <label>Account starting balance ({date || 'date'}){account.is_liability ? ' (owed shows as negative)' : ''}
        <input type="number" step="0.01" required value={amount} onChange={(e) => setAmount(e.target.value)} className="block border rounded px-2 py-1" />
      </label>
      <label>as of end of
        <input type="date" required value={date} onChange={(e) => setDate(e.target.value)} className="block border rounded px-2 py-1" />
      </label>
      <button type="submit" disabled={busy} className="px-3 py-1 bg-gray-700 text-white rounded disabled:opacity-50">Save starting balance</button>
      {error && <span className="text-red-600" role="alert">{error}</span>}
    </form>
  );
}
